import React from 'react';
import PropTypes from 'prop-types';
import './EventPreview.scss';

// A Klaviyo-delivered template has no rendered surface. This is what the flow receives.
const EventPreview = ({ event, recipientLabel }) => {
  if (!event) return <div className='event-preview-empty'>This template does not fire an event.</div>;
  if (event.error) return <div className='event-preview-empty error'>The event could not render with this data: {event.error}</div>;
  const rows = Object.entries(event.eventProperties || {});
  return (
    <div className='event-preview'>
      <div className='event-heading'>
        <span className='event-label'>Event</span>
        <span className='event-name'>{event.eventName}</span>
        {recipientLabel && <span className='event-recipient'>as Klaviyo will receive it for {recipientLabel}</span>}
      </div>
      <div className='event-table'>
        <div className='event-row head'>
          <span>Property</span>
          <span>Value</span>
          <span>Type</span>
        </div>
        {rows.map(([key, value]) => (
          <div key={key} className='event-row'>
            <span className='mono'>{key}</span>
            <span className='value'>{value === null || value === undefined ? '—' : String(value)}</span>
            <span className='type'>{value === null || value === undefined ? 'null' : typeof value}</span>
          </div>
        ))}
      </div>
      {event.uniqueId && (
        <div className='event-unique'>
          <span className='event-label'>Unique id</span>
          <span className='mono'>{event.uniqueId}</span>
        </div>
      )}
      <div className='event-note'>No rendered surface. The Klaviyo flow named for this event owns the subject line, the copy and the channel mix.</div>
    </div>
  );
};

EventPreview.propTypes = {
  event: PropTypes.object,
  recipientLabel: PropTypes.string
};

export default EventPreview;
